import {checkForWarning} from '../queryValidation'
import QueryWarning from './QueryWarning'

import React from 'react';
import {withRouter, Redirect} from "react-router-dom";

import {DeployInterface} from './DeployInterface'
import {OPERATION_MODE_DEPLOY_TEST_VARIATION} from "./DeployInterface";

import {queryApiGet, queryApiPost, UnauthorizedQueryError, RequestProcessingError} from '../api.js'

import slugify from 'slugify'
import ErrorComponent from "./error";

import deployEventsTrackerService from "../services/deployEventsTrackerService";
import {LocalStorageService} from "../services/localstorage.service";
import {SelectTestVariationLogicBranch, SelectTestVariationSettingsBranch} from "../startAbChildComponents";

import TextField from "@mui/material/TextField";

const BRANCH_REQUEST_TIMEOUT_MS = 30000

class StartAb extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            queryWarnings: {},
            redirectToAbDetailsInitiated: false,
            startAbOperationInProcess: false,
            deployComplete: false,
            errorOccurred: false,
            experimentId: "",
            testVariationSettingsBranch: 'master',
            testVariationLogicBranch: null,
            testVariationDeployed: false,
            testVariationInfo: null,
            settingsBranchesNamesLoaded: false,
            settingsBranchesNames: null,
            tagsNames: null,
            testVariationData: null,
            variationIds: null,
            showButtonVersionLogicBranch: true,
            selectVersionLogicBranch: false,
            logicAndSettingsBranch: false,
            accesses: LocalStorageService.getAccesses(),
            logicBranches: null,
            percentageForA: 50,
            percentageForB: 50,
            selectedSettingsBranch: null,
            selectedLogicVersion: null,
        };


        this.handleExperimentIdChange = this.handleExperimentIdChange.bind(this)
        this.handleTestVariationChoiceSubmit = this.handleTestVariationChoiceSubmit.bind(this)
        this.handleTestVariationDeployComplete = this.handleTestVariationDeployComplete.bind(this)
        this.handleExperimentFormSubmit = this.handleExperimentFormSubmit.bind(this)
        this.handleLogicBranchChoice = this.handleLogicBranchChoice.bind(this)
        this.processError = this.processError.bind(this)
        this.handleLogicTypeChange = this.handleLogicTypeChange.bind(this)


    }

    handleLogicTypeChange(logicType) {
        this.setState({logicType})
    }
    componentDidMount() {
        this.loadSettingsBranchesNames()

        Promise.allSettled([
            this.loadTagsNames(),
            this.loadTestVariationData()]
        ).then(data => {
            const rejected = data
                .filter(el => el.status === 'rejected')

            if (rejected.length) {
                if (rejected.some(reject => reject.reason.errorCode === 'site_does_not_exist')) {
                    this.setErrorState({
                        errorMessage: `Site does not exist. Redirecting to deploy new site page in 5sec`
                    })

                    setTimeout(() => {
                        this.setState({redirectToNewSite: true})
                    }, 5000)
                } else if (rejected.some(reject => reject.reason.errorCode === 'AB_running')) {
                    this.setErrorState({
                        errorMessage: `Site already has started AB test. Redirecting to AB test page in 5sec`
                    })

                    setTimeout(() => {
                        this.setState({redirectToAb: true})
                    }, 5000)
                } else {
                    rejected.forEach((reject) => {
                        this.setErrorState(reject.reason.errorMessage)
                    })
                }
            }
        })


        this.loadVariationIds()

        if (this.state.accesses.useLogicBranchInAB) {
            this.loadLogicBranches()
        }
    }

    loadLogicBranches() {
        let timeoutId
        const branchRequest = queryApiGet('/api/logicBranchNames')
        const timeoutError = {errorMessage: 'Branch request took too long; you can still enter a value manually'}
        const timeout = new Promise((resolve, reject) => {
                timeoutId = setTimeout(() => reject(timeoutError), BRANCH_REQUEST_TIMEOUT_MS)
        })

        branchRequest.then((logicBranches) => {
            this.setState({
                logicBranches: logicBranches.reverse(),
                logicBranchesWarning: null
            })
        }).catch((err) => {
            this.setState({
                logicBranches: [],
                logicBranchesWarning: err?.errorMessage || 'Could not load logic branches; you can still enter a value manually.'
            })
        })

        Promise.race([branchRequest, timeout]).catch((err) => {
            if (err === timeoutError) {
                this.setState({
                    logicBranches: [],
                    logicBranchesWarning: err.errorMessage
                })
            }
        }).finally(() => clearTimeout(timeoutId))
    }

    processError(e) {
        if (e instanceof UnauthorizedQueryError) {
            console.error('Unauthorized')
        } else if (e instanceof RequestProcessingError) {
            console.error(e.message)

            this.setState({
                errorOccurred: true
            })
        } else {
            throw e
        }
    }

    loadVariationIds() {
        queryApiGet(
            `/api/suggestABVariationIds?siteId=${this.props.match.params.siteId}`
        ).then((data) => {
            this.setState({
                variationIds: data.variationIds
            })
        }).catch((err) => this.setErrorState(err))
    }

    loadSettingsBranchesNames() {
        deployEventsTrackerService.trackSettingsBranchLoadingStarted();
        let timeoutId
        const settingsBranchesRequest = queryApiGet('/api/settingsBranchNames')
        const timeoutError = {errorMessage: 'Settings branch request took too long; you can still enter a value manually'}
        const timeout = new Promise((resolve, reject) => {
            timeoutId = setTimeout(() => reject(timeoutError), BRANCH_REQUEST_TIMEOUT_MS)
        })

        settingsBranchesRequest.then(data => {
             deployEventsTrackerService.trackSettingsBranchLoadingFinished()

             this.setState({
                 settingsBranchesNamesLoaded: true,
                 settingsBranchesNames: data,
                 settingsBranchesWarning: null
             })
         }).catch((err) => {
             deployEventsTrackerService.trackSettingsBranchLoadingFailed(err)
             this.setState({
                 settingsBranchesNamesLoaded: true,
                 settingsBranchesNames: [],
                 settingsBranchesWarning: err?.errorMessage || 'Could not load settings branches; you can still enter a value manually.'
             })
        })

        Promise.race([settingsBranchesRequest, timeout]).catch((err) => {
            if (err === timeoutError) {
                deployEventsTrackerService.trackSettingsBranchLoadingFailed(err)
                this.setState({
                    settingsBranchesNamesLoaded: true,
                    settingsBranchesNames: [],
                    settingsBranchesWarning: err.errorMessage
                })
            }
        }).finally(() => clearTimeout(timeoutId))
    }

    setErrorState(errorMessage) {
        this.setState({errorMessages: [...this.state.errorMessages || [], errorMessage]})
    }

    loadTagsNames() {
        deployEventsTrackerService.trackHigherVersionTagsLoadingStarted()

        return queryApiGet(
            `/api/higherVersionTagsNames?siteId=${this.props.match.params.siteId}`
        ).then(data => {
            deployEventsTrackerService.trackHigherVersionTagsLoadingFinished()

            this.setState({
                tagsNames: data,
                logicTagsWarning: null
            })
        }).catch((err) => {
            this.setState({
                tagsNames: [],
                logicTagsWarning: err?.errorMessage || 'Could not load logic tags; you can still enter a value manually.'
            })
        })
    }

    loadTestVariationData() {
        return queryApiGet(
            `/api/siteStatus?siteId=${this.props.match.params.siteId}`
        ).then(data => {
                this.setState({
                    testVariationData: data,
                    testVariationLogicBranch: data.version.logic.commitish,
                    testVariationLogicHashBranch: data.version.logic.hash.substring(0, 6),
                    testVariationSettingsHashBranch: data.version.settings.hash.substring(0, 6)
                })
        })
    }

    handleLogicBranchChoice() {
        this.setState({
            showButtonVersionLogicBranch: false,
            selectVersionLogicBranch: true
        })
    }

    handleTestVariationDeployComplete(deployedVersionInfo) {
        this.setState({
            testVariationDeployed: true,
            testVariationInfo: deployedVersionInfo
        })
    }

    handleTestVariationChoiceSubmit() {
        if (this.getSubmitButtonDisabled()) return
        const variationSettingsBranch = this.state.selectedSettingsBranch
        const rawLogicVersion = (this.state.selectedLogicVersion || this.state.testVariationData.version.logic.commitish || '')

        let variationLogicBranch = rawLogicVersion

        if (this.state.logicType === 'branch' && variationLogicBranch && !variationLogicBranch.startsWith('origin/')) {
            variationLogicBranch = 'origin/' + variationLogicBranch
        }

        this.setState({
            testVariationSettingsBranch: variationSettingsBranch,
            testVariationLogicBranch: variationLogicBranch,
            logicAndSettingsBranch: true
        })
    }

    handleExperimentIdChange(e) {
        const experimentId = slugify(e.target.value, {replacement: '_', lower: true})
        checkForWarning(this, 'experimentId', experimentId)
        this.setState({experimentId})
    }

    adjustSecondVariationPercentageAfterInput(variation, event) {
        let value = event.target.value

        // Todo find the way to path min and max value to mui input
        if (value > 99) value = 99
        if (value < 1) value = 1

        if (variation === 'a') {
            this.setState({
                percentageForB: 100 - value,
                percentageForA: value
            })
        }

        if (variation === 'b') {
            this.setState({
                percentageForA: 100 - value,
                percentageForB: value
            })
        }
    }

    handleExperimentFormSubmit(e) {
        e.preventDefault()

        const d = new FormData(e.target)
        if (this.state.queryWarnings.experimentId || !this.state.experimentId) return

        this.setState({
            startAbOperationInProcess: true
        })

        deployEventsTrackerService.trackAbStarted()

        queryApiPost(
             `/api/startAb?siteId=${this.props.match.params.siteId}&experimentId=${d.get('experiment_id')}&variationIds=${this.state.variationIds.join(',')}&split=${[this.state.percentageForA, this.state.percentageForB]}`,
            {
                method: 'POST',
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('token')
                }
            }
        ).then(() => {
            deployEventsTrackerService.trackABbFinished()

            this.setState({
                startAbOperationInProcess: false,
                deployComplete: true
            })

            setTimeout(() => {
                this.setState({
                    redirectToAbDetailsInitiated: true
                })
            }, 1500)
        })
        .catch((err) => {
            deployEventsTrackerService.trackAbFailed(err.errorMessage)

            this.setErrorState(err)
        })
    }

    getSubmitButtonDisabled() {
       if (this.state.queryWarnings.settingsBranch || this.state.queryWarnings.logic) return true
       const selectedSettingsBranch = this.state.selectedSettingsBranch
       const selectedLogicVersion = this.state.selectedLogicVersion?.trim()

       if (this.state.showButtonVersionLogicBranch) {
           return !selectedSettingsBranch
       }

       if (!this.state.showButtonVersionLogicBranch) {
           return !(selectedSettingsBranch && selectedLogicVersion)
       }
    }

    renderSoftWarnings() {
        const warnings = [
            this.state.logicTagsWarning,
            this.state.logicBranchesWarning,
            this.state.settingsBranchesWarning
        ].filter(Boolean)

        if (!warnings.length) {
            return null
        }

        return (
            <div style={{marginTop: '12px', marginBottom: '12px'}}>
                {warnings.map((warning, index) => (
                    <div key={index} style={{color: '#ffcc00', fontSize: 12}}>
                        Warning: {warning}
                    </div>
                ))}
            </div>
        )
    }

    onSettingsBranchSelected(settingsBranch) {
        checkForWarning(this, 'settingsBranch', settingsBranch)
        this.setState({selectedSettingsBranch: settingsBranch})
    }

    onLogicVersionSelected(logicVersion) {
        checkForWarning(this, 'logic', logicVersion)
        this.setState({selectedLogicVersion: logicVersion})
    }

    getLogicOptionsLoadingState() {
        const logicPermissionEnabled = this.state.accesses?.useLogicBranchInAB

        if (!logicPermissionEnabled || this.state.showButtonVersionLogicBranch) {
            return false
        }

        if (this.state.showTags) {
            return this.state.tagsNames === null
        }

        return this.state.logicBranches === null
    }

    render () {
        if (this.state.redirectToNewSite) {
           return ( <Redirect
                to={`/newSite`}
            />)
        } if (this.state.redirectToAb) {
           return (<Redirect
                to={`/updateAb/${this.props.match.params.siteId}/replaceWithExperimentId`}
            />)
        } else if (this.state.errorMessages?.length) {
            return (<ErrorComponent errorMessages={this.state.errorMessages} />)
        } else if (!this.state.testVariationData || !this.state.variationIds || !this.state.settingsBranchesNamesLoaded || (this.state.accesses.useLogicBranchInAB && this.state.logicBranches === null)) {
            return 'Gathering information. Please wait ...'
        } else if (this.state.redirectToAbDetailsInitiated) {
            return (
                <Redirect
                    to={`/experimentDescriptionGenerator/${this.props.match.params.siteId}/${this.state.experimentId}/${this.state.variationIds.join(',')}/${[this.state.percentageForA, this.state.percentageForB].map(el => el / 100)}`}
                />
            )
        } else if (this.state.deployComplete) {
            return <span style={{fontSize: 25, backgroundColor: '#009933', color: 'Yellow'}}>Experiment has started!</span>
        } else if (this.state.startAbOperationInProcess) {
            return 'Please wait ...'
        } else if (!this.state.logicAndSettingsBranch) {
            return (
                <form style={{minWidth: '60vw'}} onSubmit={e => { e.preventDefault(); this.handleTestVariationChoiceSubmit() }}>
                    <div>
                        Variations: {this.state.variationIds.join(', ')}
                    </div>
                    {this.renderSoftWarnings()}
                    <QueryWarning message={[this.state.queryWarnings.settingsBranch, this.state.queryWarnings.logic].filter(Boolean).join(' ')} />
                    <SelectTestVariationLogicBranch
                        selectVersionLogicBranch={this.state.selectVersionLogicBranch}
                        handlerLogicBranch={this.handleLogicBranchChoice}
                        handleLogicTypeChange={this.handleLogicTypeChange}
                        accesses={this.state.accesses}
                        testVariationData={this.state.testVariationData}
                        siteId={this.state.siteId}
                        tagsNames={this.state.tagsNames}
                        logicBranches={this.state.logicBranches}
                        selectUpdate={this.state.selectVersionLogicBranch}
                        showButtonVersionLogicBranch={this.state.showButtonVersionLogicBranch}
                        onLogicVersionSelected={this.onLogicVersionSelected.bind(this)}
                        logicVersionValue={this.state.selectedLogicVersion}
                        optionsLoading={this.getLogicOptionsLoadingState()}
                        testVariationId={this.state.variationIds[1]}

                    />
                    <SelectTestVariationSettingsBranch
                        settingsBranchesNames={this.state.settingsBranchesNames}
                        selectedSettingsBranch={this.state.selectedSettingsBranch}
                        settingsLoading={!this.state.settingsBranchesNamesLoaded}
                        testVariationId={this.state.variationIds[1]}
                        onSettingsBranchSelected={this.onSettingsBranchSelected.bind(this)}
                    />
                    <button disabled={this.getSubmitButtonDisabled()} type="submit" style={{width: '250px', height: '60px', fontSize: 25, marginTop: '20px', cursor: 'pointer'}}>Continue</button>
                </form>
            )
        } else if (!this.state.testVariationDeployed) {
            return <DeployInterface
                operationMode={OPERATION_MODE_DEPLOY_TEST_VARIATION}
                variation={this.state.variationIds[1]}
                siteId={this.props.match.params.siteId}
                settingsBranch={this.state.testVariationSettingsBranch}
                settingsHashBranch={this.state.testVariationSettingsHashBranch}
                logic={this.state.testVariationLogicBranch}
                logicHash={this.state.testVariationLogicHashBranch}
                onDeployComplete={this.handleTestVariationDeployComplete}
            />
        }


        return (

            <form onSubmit={this.handleExperimentFormSubmit}>
                <QueryWarning message={this.state.queryWarnings.experimentId} />
                <table cellSpacing={10}>
                    <tbody>
                        <tr>
                            <td>Experiment ID:</td>
                            <td><input onChange={this.handleExperimentIdChange} style={{width: '100%'}} required pattern=".{3,50}"/></td>
                        </tr>
                        <tr>
                            <td>
                                Experiment ID (final):
                            </td>
                            <td>
                                {this.state.experimentId}
                                <input type="hidden" name="experiment_id" value={this.state.experimentId}/>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Variation {this.state.variationIds[0]}:
                            </td>
                            <td>
                                current version used on production
                            </td>
                            <td>
                                <span style={{marginLeft: '15px' }}> Percentage for variation A: {this.state.percentageForA}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Settings branch for variation {this.state.variationIds[1]}:
                            </td>
                            <td>
                                Logic: {this.state.testVariationInfo.logic.commitish} / {this.state.testVariationInfo.logic.hash.substring(0, 6)}<br />
                                Settings: {this.state.testVariationInfo.settings.commitish} / {this.state.testVariationInfo.settings.hash.substring(0, 6)}<br />
                            </td>
                            <td>
                                <TextField
                                    onInput={(event) => this.adjustSecondVariationPercentageAfterInput('b', event)}
                                    id="percentageForB"
                                    label="Percent for B"
                                    type="number"
                                    variant="filled"
                                    value={this.state.percentageForB}
                                    slotProps={{
                                        inputLabel: {
                                            shrink: true
                                        }
                                    }}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={2}>
                                <button type="submit" disabled={!!this.state.queryWarnings.experimentId || !this.state.experimentId} style={{width: '250px', height: '60px', fontSize: 25}}>Start A/B</button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </form>
        )

    }
}



export default withRouter(StartAb)
